<template>
  <div class="product">
    <el-row>
      <el-col class="pro-left">
        <h2>产品系列</h2>
        <p class="underline"></p>
        <p class="pro-p">Product Series</p>
      </el-col>
      <el-col
        class="pro-right"
        @mouseenter.native="mouseEnterR"
        @mouseleave.native="mouseLeaveR"
      >
        <swiper v-if="productShow" :options="productOption" ref="productSwiper">
          <swiper-slide
            v-for="(item, index) of productList"
            :key="'product-' + index"
          >
            <div class="imgoutdiv">
              <img :src="item.image" alt />
            </div>
            <div class="swiper_bor">
              <div class="swiper_title">{{ item.name_ch }}</div>
              <div class="swiper_content">{{ item.remark | getText }}</div>
              <button
                class="more productListmore"
                :data-obj="JSON.stringify(item)"
              >
                查看详情
              </button>
            </div>
          </swiper-slide>
        </swiper>
        <div
          class="btn btn-prev"
          @click="$refs.productSwiper.$swiper.slidePrev()"
          v-show="btnShowR"
        ></div>
        <div
          class="btn btn-next"
          @click="$refs.productSwiper.$swiper.slideNext()"
          v-show="btnShowR"
        ></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="pro-left">
        <h2>业务系列</h2>
        <p class="underline"></p>
        <p class="pro-p">Business Series</p>
      </el-col>
      <el-col
        class="pro-right"
        @mouseenter.native="mouseEnterL"
        @mouseleave.native="mouseLeaveL"
      >
        <swiper
          v-if="businessShow"
          :options="businessOption"
          ref="businessSwiper"
        >
          <swiper-slide
            v-for="(item, index) of businessList"
            :key="'business-' + index"
          >
            <div class="imgoutdiv">
              <img :src="item.image" alt />
            </div>
            <div class="swiper_bor">
              <div class="swiper_title">{{ item.name_ch }}</div>
              <div class="swiper_content">{{ item.remark | getText }}</div>
              <button
                class="more businessListmore"
                :data-obj="JSON.stringify(item)"
              >
                查看详情
              </button>
            </div>
          </swiper-slide>
        </swiper>
        <div
          class="btn btn-prev"
          @click="$refs.businessSwiper.$swiper.slidePrev()"
          v-show="btnShowL"
        ></div>
        <div
          class="btn btn-next"
          @click="$refs.businessSwiper.$swiper.slideNext()"
          v-show="btnShowL"
        ></div>
      </el-col>
      <el-dialog
        :visible.sync="dialogVisible"
        width="991px"
        :title="showData.name_ch"
      >
        <div class="dialogContent">
          <div
            class="dialogImg"
            v-if="
              showData.notification_images &&
              showData.notification_images.length > 0
            "
          >
            <swiper
              v-if="showData.notification_images.length"
              :options="notificationImagesOption"
              ref="notificationImagesSwiper"
            >
              <swiper-slide
                v-for="(item, index) of showData.notification_images"
                :key="index"
              >
                <div class="dialogInImage">
                  <el-image
                    style="width: 225px; height: 400px"
                    :src="item"
                    fit="cover"
                  ></el-image>
                </div>
              </swiper-slide>
            </swiper>
            <img
              src="./../../assets/home/prev3.png"
              class="swiper-button-prev"
              @click="$refs.notificationImagesSwiper.$swiper.slidePrev()"
              alt=""
              v-if="showSlidePrev"
            />
            <img
              src="./../../assets/home/next3.png"
              class="swiper-button-next"
              @click="$refs.notificationImagesSwiper.$swiper.slideNext()"
              alt=""
              v-if="showSlideNext"
            />
          </div>
          <div v-html="showData.remark" class="claim-p"></div>
        </div>
        <div
          v-if="showData.jump_url && showData.jump_url.length > 0"
          class="dialogButtom"
        >
          <a
            :href="item.url"
            target="_blank"
            v-for="(item, index) of showData.jump_url"
            :key="index"
            >{{ item.name }}</a
          >
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
const proBusAllUri = "website/index/pro/bus/get/all";

let vm = null;
export default {
  data() {
    return {
      productOption: {
        slidesPerView: "auto",
        spaceBetween: 48,
        loop: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        on: {
          init: function () {
            vm.productinitEvent();
          },
        },
      },
      productList: [],
      productShow: false,
      businessOption: {
        slidesPerView: "auto",
        spaceBetween: 48,
        loop: false,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        on: {
          init: function () {
            vm.businessinitEvent();
          },
        },
      },
      businessList: [],
      businessShow: false,
      dialogVisible: false,
      showData: {},
      btnShowR: false,
      btnShowL: false,
      notificationImagesOption: {
        slidesPerView: 3.7,
        spaceBetween: 20,
        loop: false,
      },
      showSlidePrev: false,
      showSlideNext: false,
    };
  },
  created() {
    vm = this;
    this.initSwiper();
    this.getProBusAll();
  },
  filters: {
    // 获取文本内容
    getText(str) {
      if (str.indexOf("<") == -1) {
        return str;
      } else {
        let result = "";
        let flag = false;
        for (let char of str) {
          if (char === ">") {
            flag = true;
          }
          if (char === "<") {
            flag = false;
          }
          if (flag && char !== ">") {
            result =
              result.replace(/&nbsp;/g, "") + char.replace(/&nbsp;/g, "");
          }
        }
        return result;
      }
    },
  },
  methods: {
    mouseEnterR() {
      this.btnShowR = true;
    },
    mouseLeaveR() {
      this.btnShowR = false;
    },
    mouseEnterL() {
      this.btnShowL = true;
    },
    mouseLeaveL() {
      this.btnShowL = false;
    },
    // 轮播初始化
    initSwiper() {
      let proConfig = this.$cache.get("productConfig");
      if (proConfig) {
        this.productOption.autoplay.delay = proConfig.interval_time;
      }
      let busConfig = this.$cache.get("businessConfig");
      if (busConfig) {
        this.businessOption.autoplay.delay = busConfig.interval_time;
      }
    },
    getProBusAll() {
      this.getProductAll();
      this.getBusinessAll();
    },
    // 获取所有产品
    getProductAll() {
      this.$api
        .get(proBusAllUri, {
          pro_bus: 1,
        })
        .then((res) => {
          if (res.list.length > 2) {
            this.productOption.loop = true;
          }
          this.productList = res.list;
          this.$nextTick(() => {
            this.productShow = true;
          });
          this.productOption.on = {
            click() {
              let index = this.clickedIndex - this.activeIndex + this.realIndex;
              vm.productinitEvent(index);
            },
          };
        });
    },
    // 获取所有业务
    getBusinessAll() {
      this.$api
        .get(proBusAllUri, {
          pro_bus: 2,
        })
        .then((res) => {
          if (res.list.length > 2) {
            this.businessOption.loop = true;
          }
          this.businessList = res.list;
          this.$nextTick(() => {
            this.businessShow = true;
          });
          this.businessOption.on = {
            click() {
              let index = this.clickedIndex - this.activeIndex + this.realIndex;
              vm.businessinitEvent(index);
            },
          };
        });
    },
    // 产品初始化事件
    productinitEvent(e) {
      let index = e;
      if (index == this.productList.length) {
        index = 0;
      } else if (index == this.productList.length + 1) {
        index = 1;
      } else if (index == this.productList.length + 2) {
        index = 2;
      }
      this.showData = this.productList[index];
      this.showItem();
    },
    // 业务初始化事件
    businessinitEvent(e) {
      let index = e;
      if (index == this.businessList.length) {
        index = 0;
      } else if (index == this.businessList.length + 1) {
        index = 1;
      } else if (index == this.businessList.length + 2) {
        index = 2;
      }
      this.showData = this.businessList[index];
      this.showItem();
    },
    showItem() {
      this.showSlideNext = false;
      this.showSlidePrev = false;
      this.dialogVisible = true;
      if (this.showData.notification_images.length > 3) {
        this.showSlideNext = true;
      }
      this.notificationImagesOption.on = {
        transitionEnd() {
          if (this.isEnd) {
            vm.showSlideNext = false;
          } else {
            vm.showSlideNext = true;
          }
          if (this.activeIndex > 0) {
            vm.showSlidePrev = true;
          } else {
            if (
              !vm.showSlideNext &&
              vm.showData.notification_images.length == 4
            ) {
              vm.showSlidePrev = true;
            } else {
              vm.showSlidePrev = false;
            }
          }
        },
      };
    },
  },
};
</script>
<style lang="less" scoped>
.product {
  width: 1200px;
  margin: 0 auto;

  .el-row {
    background: #fff;
    display: flex;
    align-items: center;
    h1 {
      font-size: 30px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 15px;
      padding: 0 36px;
      line-height: 30px;
    }
    ::v-deep .el-dialog {
      border-radius: 8px;
      overflow: hidden;
    }
    ::v-deep .el-dialog__header {
      padding: 20px 48px;
      .el-dialog__title {
        font-size: 20px;
      }
    }
    ::v-deep .el-dialog__body {
      border-top: 1px solid #eeeeee;
      padding: 0;
      position: relative;
    }
    .dialogContent {
      padding: 0px 48px 80px;
      max-height: 625px;
      overflow: auto;
      .claim-p {
        font-size: 16px;
        color: #555555;
        line-height: 22px;
        margin: 32px 0;
      }
      .dialogImg {
        position: relative;
        margin-top: 32px;
        .dialogInImage {
          ::v-deep .el-image__inner {
            border-radius: 4px;
          }
        }
        .swiper-button-prev {
          width: 40px;
          height: 40px;
          position: absolute;
          left: 6px;
        }
        .swiper-button-next {
          width: 40px;
          height: 40px;
          position: absolute;
          right: 6px;
        }
      }
    }
    .dialogButtom {
      box-shadow: 0px -0.5px 15px #f9f2f0;
      height: 80px;
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #ffffff;
      padding: 0 48px;
      border-radius: 0 0 8px 8px;
      a {
        margin-right: 10px;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        color: #ff5619;
        padding: 0 12px;
        border: 1px solid #ff5619;
      }
    }
    .pro-left {
      min-width: 257px;
      width: 257px;
      padding-left: 48px;
      h2 {
        font-size: 30px;
        font-weight: 500;
        color: #333333;
      }
      .underline {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin: 36px 0 41px 0;
      }
      .pro-p {
        font-size: 24px;
        color: #999999;
      }
    }
    .pro-right {
      position: relative;
      overflow: hidden;
      .swiper-container {
        margin: 27px 50px;
        margin-right: 0;

        .swiper-slide {
          width: 286px;
          font-size: 0;
          .imgoutdiv {
            width: 286px;
            height: 286px;
            img {
              width: 286px;
              height: 286px;
            }
          }
          .swiper_bor {
            border: 1px solid #eeeeee;
            border-radius: 0 0 2px 2px;
            padding-bottom: 16px;
            .swiper_title {
              font-size: 18px;
              font-weight: 500;
              color: #333;
              line-height: 27px;
              padding-left: 16px;
              margin-top: 16px;
            }
            .swiper_content {
              font-size: 14px;
              color: #555555;
              line-height: 24px;
              padding: 8px 16px 0 16px;
              overflow: hidden;
              display: -webkit-box; //将元素设为盒子伸缩模型显示
              -webkit-box-orient: vertical; //伸缩方向设为垂直方向
              -webkit-line-clamp: 2; //超出3行隐藏，并显示省略号
            }
            .more {
              font-size: 14px;
              color: #e60616;
              height: 24px;
              line-height: 28px;
              padding: 0;
              margin-left: 16px;
              border: none;
              background-color: #ffffff;
              // img {
              //   width: 15px;
              //   height: 5px;
              //   vertical-align: middle;
              //   margin-left: 8px;
              // }
            }
          }
        }
      }
      .btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 32px;
        height: 64px;
        cursor: pointer;
        z-index: 2;
      }
      .btn-prev {
        left: 0;
        background-image: url("../../assets/home/prev2.png");
        background-size: 100% 100%;
      }
      .btn-next {
        right: 0;
        background-image: url("../../assets/home/next2.png");
        background-size: 100% 100%;
      }
    }
  }
  .el-row:last-child {
    margin-top: 36px;
  }
}
</style>


